import * as React from "react";

const SvgAVGen = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 21 20"
    fill="none"
  >
    <g clipPath="url(#clip0_13050_2766)">
      <path
        d="M4.25 5C4.25 4.30964 4.80964 3.75 5.5 3.75H15.5C16.1904 3.75 16.75 4.30964 16.75 5V15C16.75 15.6904 16.1904 16.25 15.5 16.25H5.5C4.80964 16.25 4.25 15.6904 4.25 15V5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
      />
      <rect
        x="0.5"
        y="4"
        width="1.5"
        height="12"
        rx="0.75"
        fill="currentColor"
      />
      <rect
        x="19"
        y="4"
        width="1.5"
        height="12"
        rx="0.75"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.0212 13.3724C8.69277 13.6278 8.21423 13.3938 8.21423 12.9777V7.02232C8.21423 6.60625 8.69277 6.3722 9.0212 6.62764L12.8496 9.60532C13.107 9.8055 13.107 10.1945 12.8496 10.3947L9.0212 13.3724Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_13050_2766">
        <rect
          width="1em"
          height="1em"
          fill="currentColor"
          transform="translate(0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default SvgAVGen;
